const menuToggle = document.querySelector('.mobile-menu-toggle');
const navLinks = document.querySelector('.nav-links-wrapper');
const overlay = document.querySelector('.nav-overlay');
const closeBtn = document.querySelector('.mobile-menu-close');

function openNav() {
  navLinks.classList.add('active');
  overlay.classList.add('active');
  document.body.style.overflow = 'hidden';
}

function closeNav() {
  navLinks.classList.remove('active');
  overlay.classList.remove('active');
  document.body.style.overflow = '';
}

menuToggle.addEventListener('click', openNav);
closeBtn.addEventListener('click', closeNav);
overlay.addEventListener('click', closeNav);
document.addEventListener('keydown', e => {
  if (e.key === 'Escape' && navLinks.classList.contains('active')) closeNav();
});